import styled from "styled-components";
import { NavLink } from "react-router-dom";

// Bottom navigation (PRD §IA): home / quest / board / me. No Map, no Riddle tab
// (Riddle is a modal opened from Home).
const TABS = [
  { to: "/", label: "home", icon: "◉" },
  { to: "/quest", label: "quest", icon: "⌬" },
  { to: "/board", label: "board", icon: "≡" },
  { to: "/me", label: "me", icon: "◐" },
] as const;

const Bar = styled.nav`
  position: sticky;
  bottom: 0;
  z-index: 10;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background: rgba(8, 9, 12, 0.92);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-top: 1px solid ${({ theme }) => theme.color.border};
  padding-bottom: env(safe-area-inset-bottom);
`;

const Tab = styled(NavLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: ${({ theme }) => `${theme.space(2)} 0`};
  text-decoration: none;
  color: ${({ theme }) => theme.color.textFaint};
  font-family: ${({ theme }) => theme.font.mono};
  font-size: 11px;

  &.active {
    color: ${({ theme }) => theme.color.accent};
  }
`;

const Icon = styled.span`
  font-size: 18px;
  line-height: 1;
`;

export function TabBar() {
  return (
    <Bar>
      {TABS.map((t) => (
        <Tab key={t.to} to={t.to} end={t.to === "/"}>
          <Icon>{t.icon}</Icon>
          {t.label}
        </Tab>
      ))}
    </Bar>
  );
}
